import { render, staticRenderFns } from "./PublicacionNoticia.vue?vue&type=template&id=7382a9b5&scoped=true&"
import script from "./PublicacionNoticia.vue?vue&type=script&lang=ts&"
export * from "./PublicacionNoticia.vue?vue&type=script&lang=ts&"
import style0 from "./PublicacionNoticia.vue?vue&type=style&index=0&id=7382a9b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7382a9b5",
  null
  
)

export default component.exports